// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"187a006d","392":"3d1f69f7","756":"3542fd7c"}[chunkId] + ".chunk.css";
};